// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sub-menu-item[data-v-04805182] {\n  font: bold 16px Merriweather, serif;\n  text-transform: none;\n}\n.sub-menu-item-icon[data-v-04805182] {\n  margin-right: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
